import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import axios from "axios";

const isTokenValid = () => {
  const token = localStorage.getItem("token");
  const createdAt = localStorage.getItem("token_created_at");
  if (!token || !createdAt) return false;

  const tokenDate = new Date(createdAt);
  const now = new Date();
  const diffDays = (now - tokenDate) / (1000 * 3600 * 24);

  return diffDays <= 10;
};

// routes that require subscription check
const contentProtectedRoutes = ["/dashboard/content", "/content/all", "/content-details"];

const PrivateRoute = ({ component: Component, path, ...rest }) => {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [subscriptionChecked, setSubscriptionChecked] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!isTokenValid()) {
      setHasAccess(false);
      setLoading(false);
      return;
    }

    // Only check subscription for content-protected routes
    if (contentProtectedRoutes.includes(path)) {
      axios
        .get(`${API_BASE_URL}/user/content-access`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        .then((res) => {
          const active = res.data.some((order) => order.remaining_days > 0);
          setHasAccess(active);
          setSubscriptionChecked(true);
          setLoading(false);
        })
        .catch(() => {
          setHasAccess(false);
          setSubscriptionChecked(true);
          setLoading(false);
        });
    } else {
      setHasAccess(true); // all other routes just need a valid token
      setLoading(false);
    }
  }, [API_BASE_URL, path]);

  if (loading) return <p>Loading...</p>;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isTokenValid()) {
          // Token invalid → force login
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("token_created_at");
          return <Redirect to="/login" />;
        }

        // If it's a content route and user has no active subscription → show "Access Denied"
        if (contentProtectedRoutes.includes(path) && subscriptionChecked && !hasAccess) {
          return (
            <div style={{ padding: "50px", textAlign: "center" }}>
              <h2>Access Denied</h2>
              <p>You don’t have permission to view this page.</p>
            </div>
          );
        }

        // Otherwise → render the component
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
